import { type ColumnWithLooseAccessor } from 'react-table';

export type VerificationListItem = ColumnWithLooseAccessor & {
  docType: string;
  totalNumberOfBatches: number | string;
  totalNoofDocuments: number | string;
  status: string;
  docTypeID: number;
  batchID: number;
  totalNoofBatches: number;
};

export interface VerificationFieldListTypesResponse {
  doctypeID: number;
  fieldID: number;
  fieldName: string;
  technique: string;
  componentID: number;
  techID: number;
}

export interface VerificationFieldListTypes {
  doctypeID: number;
  fieldID: number;
  fieldName: string;
  techniques: VerificationFieldListTypesResponse[];
}

export interface VerificationFileDetails {
  doctypeID: number;
  batchID: number;
  batchPath: string;
  docType: string;
  fileName: string;
  totalPages: number;
  fileID: number;
}

export interface VerificationPatternsListTypes {
  batchId: number;
  taxonomyID: number;
  fileID: number;
  fieldName: string;
  pattern: string;
  pageNumber: number;
  fieldID: number;
  fileName: string;
  techID: number;
  componentName: string;
  userName: string;
  entryDate: string;
  docTypeID: number;
  docType: string;
  patternROI: string;
  totalPage: number;
  columnID: number;
   processID: number;
}

export interface VerificationBatchListTypes {
  docTypeID: number;
  docType: string;
  batchID: number;
  fileCount: number;
  status: string;
}

export interface VerifiactionFileDetailsTypes {
  fileID: number;
  batchID: number;
  fileName: string;
  docTypeId: number;
  docType: string;
  totalPages: number;
  processID: number;
}

export type VerificationPatternFilterTypes = 'UNIQUE' | 'ALL';

export const VERIFICATION_SELECTE_PATTERN_TYPE: { value: VerificationPatternFilterTypes; label: string }[] = [
  {
    value: 'UNIQUE',
    label: 'Unique Pattern'
  },
  {
    value: 'ALL',
    label: 'All Pattern'
  }
];

export interface VerifcaitonNewPatternPayloadType {
  fileId: number;
  fieldId: number;
  techId: number;
  taxonomyID: number;
  isKeyValuePair: boolean;
  patternValue: string;
  patternROI: string;
  patternPageNo: number;
  contentDirectionID: number;
  sectionHeader: string;
  sectionFooter: string;
  isExpression: boolean;
  expressionPattern: string;
  expressionRegex: string;
  isLookup: boolean;
  documentPattern: string;
  displayValue: string;
  columnID?: number;
  IsContextCloud?: any;
}

export enum VerificationTechniquesEnum {
  KEY_VALUE_PAIR = 'KeyValuePair',
  EXPRESSION = 'Expression',
  LOOKUP = 'Lookup',
  TABLE = 'Table',
  TABLE_PRINTED = 'Table Printed',
  Context_Based = 'Context Based',
  Nested_Key_Printed = 'NestedKeyvaluepairprinted',
  Nested_Lookup_Printed = 'NestedLookupPrinted'
}

export const VerificationTechniquesLabelEnum = {
  [VerificationTechniquesEnum.KEY_VALUE_PAIR]: VerificationTechniquesEnum.KEY_VALUE_PAIR,
  [VerificationTechniquesEnum.EXPRESSION]: VerificationTechniquesEnum.EXPRESSION,
  [VerificationTechniquesEnum.LOOKUP]: VerificationTechniquesEnum.LOOKUP,
  [VerificationTechniquesEnum.TABLE]: VerificationTechniquesEnum.TABLE,
  [VerificationTechniquesEnum.TABLE_PRINTED]: VerificationTechniquesEnum.TABLE_PRINTED,
  [VerificationTechniquesEnum.Context_Based]: VerificationTechniquesEnum.Context_Based,
  [VerificationTechniquesEnum.Nested_Key_Printed]: VerificationTechniquesEnum.Nested_Key_Printed,
  [VerificationTechniquesEnum.Nested_Lookup_Printed]: VerificationTechniquesEnum.Nested_Lookup_Printed
};

export type VerificationTechniquesType =
  | VerificationTechniquesEnum.KEY_VALUE_PAIR
  | VerificationTechniquesEnum.EXPRESSION
  | VerificationTechniquesEnum.LOOKUP
  | VerificationTechniquesEnum.TABLE
  | VerificationTechniquesEnum.TABLE_PRINTED;

export const ImageViewerAddButtonNameByPattern = {
  [VerificationTechniquesEnum.KEY_VALUE_PAIR]: 'Add Label',
  [VerificationTechniquesEnum.EXPRESSION]: 'Add Expression',
  [VerificationTechniquesEnum.LOOKUP]: 'Add Lookup',
  [VerificationTechniquesEnum.TABLE]: 'Add Table'
};

export interface VerificationTechniquesInputTypes {
  label: string;
  name: string;
  onChange?: (_a: any, setFieldValue: any) => void;
  readOnly?: boolean;
  disabled?: boolean;
  defaultValue?: string;
}

export interface VerificationTechniquesInputListTypes {
  [VerificationTechniquesEnum.KEY_VALUE_PAIR]: VerificationTechniquesInputTypes[];
  [VerificationTechniquesEnum.EXPRESSION]: VerificationTechniquesInputTypes[];
  [VerificationTechniquesEnum.LOOKUP]: VerificationTechniquesInputTypes[];
  [VerificationTechniquesEnum.TABLE]: VerificationTechniquesInputTypes[];
  [VerificationTechniquesEnum.TABLE_PRINTED]: VerificationTechniquesInputTypes[];
}

export enum VerifiationStatusTypes {
  READY_FOR_TRAINING = 'READYFORTRAINING',
  CURATION_COMPLETED = 'CURATIONCOMPLETED',
  READYFORCURATION = 'READYFORCURATION',
  CURATIONINPROGRESS = 'CURATIONINPROGRESS',
  CURATIONINCOMPLETE = 'CURATIONINCOMPLETE'
}

const typePrefix = 'VERIFICATION_IMAGE_VIEWER_';
export const VERIFICATION_IMAGE_VIEWER_DUAL_SCREEN_ACTIONS = {
  LATEST_STATE: `${typePrefix}LATEST_STATE`,
  GET_LATEST_STATE: `${typePrefix}GET_LATEST_STATE`,
  CLIENT_STATE_UPDATED: `${typePrefix}CLIENT_STATE_UPDATED`,
  ON_SELECT_PATTERN: `${typePrefix}ON_SELECT_PATTERN`,
  SUBMIT_ADD_EDIT_PATTERN: `${typePrefix}SUBMIT_ADD_EDIT_PATTERN`
};

export interface AddTablePatternPayload {
  taxonomyID: number;
  columnID: number;
  patternValue: string;
  patternROI: string;
  patternPageNo: number;
  fileId: number;
  fieldId: number;
  techId: number;
}

export interface UpdateTablePatternPayload {
  taxonomyID: number;
  columnID: number;
  patternValue: string;
  patternROI: string;
  patternPageNo: number;
}
